var map = {
	"./faq_EN.js": 130,
	"./faq_SV.js": 131
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 562;


//////////////////
// WEBPACK FOOTER
// ./pages/content ^\.\/faq_.*\.js$
// module id = 562
// module chunks = 0